/** Automatski tagovi: Popunjeno (prošlo), Last Minute (10 dana prije polaska). */

const LAST_MINUTE_DAYS_BEFORE = 10;
const PRESERVE_TAG_KEYS = new Set(["valencia"]);

function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

function toDateOnly(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function parseTourDate(dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T12:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** true ako je danas u zadnjih N dana prije polaska (ne uključujući dan polaska). */
export function isInLastMinuteWindow(departureDateStr, today = startOfToday()) {
  const departure = parseTourDate(departureDateStr);
  if (!departure) return false;

  const departureDay = toDateOnly(departure);
  if (departureDay <= today) return false;

  const lastMinuteStart = new Date(departureDay);
  lastMinuteStart.setDate(lastMinuteStart.getDate() - LAST_MINUTE_DAYS_BEFORE);
  return today >= lastMinuteStart;
}

export function resolveTourTag(tour, today = startOfToday()) {
  if (!tour) return tour?.tag;
  if (PRESERVE_TAG_KEYS.has(tour.key)) return tour.tag;

  const departure = parseTourDate(tour.date);
  if (!departure) return tour.tag;

  const departureDay = toDateOnly(departure);
  if (departureDay <= today) return "Popunjeno";
  if (isInLastMinuteWindow(tour.date, today)) return "Last Minute";

  return tour.tag;
}

export function normalizeTourTags(tours) {
  if (!Array.isArray(tours)) return tours;
  const today = startOfToday();

  return tours.map((tour) => {
    if (!tour) return tour;
    if (PRESERVE_TAG_KEYS.has(tour.key)) return tour;

    const tag = resolveTourTag(tour, today);
    return tag === tour.tag ? tour : { ...tour, tag };
  });
}
